import React, { createContext, useContext, useState, ReactNode } from "react";
import { ArtistSubscription } from "../services/artistSubscriptionService";

interface AuthContextProps {
  userRole: string | null;
  token: string | null;
  subscriptionStatus: ArtistSubscription | null;
  isSubscriptionValid: () => boolean;
  login: (token: string, role: string) => void;
  logout: () => void;
  setSubscriptionStatus: (subscription: ArtistSubscription | null) => void;
}

const AuthContext = createContext<AuthContextProps>({
  userRole: null,
  token: null,
  subscriptionStatus: null,
  isSubscriptionValid: () => false,
  login: () => {},
  logout: () => {},
  setSubscriptionStatus: () => {},
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string | null>(
    localStorage.getItem("token")
  );
  const [userRole, setUserRole] = useState<string | null>(
    localStorage.getItem("role")
  );
  const [subscriptionStatus, setSubscriptionStatus] = useState<ArtistSubscription | null>(null);

  const isSubscriptionValid = (): boolean => {
    if (!subscriptionStatus) return false;
    if (!subscriptionStatus.isActive) return false;
    
    const endDate = new Date(subscriptionStatus.endDate);
    const now = new Date();
    return endDate > now;
  };

  const login = (newToken: string, role: string) => {
    localStorage.setItem("token", newToken);
    localStorage.setItem("role", role);
    setToken(newToken);
    setUserRole(role);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("forcePasswordChange");
    setToken(null);
    setUserRole(null);
    setSubscriptionStatus(null);
  };

  return (
    <AuthContext.Provider value={{ token, userRole, subscriptionStatus, isSubscriptionValid, login, logout, setSubscriptionStatus }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
